import styled from "styled-components";

export const ActiveFilterWrapper = styled.div`
  height: 35px;
  border: 0.5px solid #e1e1e1;
  border-radius: 8px;
  padding: 0 15px;
  width: fit-content;

  .content-text {
    font-size: 16px;
    line-height: 19px;
    text-transform: capitalize;
    white-space: nowrap;
  }
`;
